import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { getSvgContent } from "../../../helpers/sidebar";

interface SvgIconProps {
  iconUrl: string;
  color?: string;
  isActive?: boolean;
  activeColor?: string;
  width?: string;
  height?: string;
  className?: string;
}

const SvgContainer = styled.div<{
  width?: string;
  height?: string;
  color?: string;
  isActive?: boolean;
  activeColor?: string;
}>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;

    path,
    circle,
    rect,
    polygon,
    line,
    polyline {
      stroke: ${(props) => {
        if (props.isActive && props.activeColor) return props.activeColor;
        return props.color || "currentColor";
      }};
    }

    path[fill]:not([fill="none"]),
    circle[fill]:not([fill="none"]),
    rect[fill]:not([fill="none"]),
    polygon[fill]:not([fill="none"]) {
      fill: ${(props) => {
        if (props.isActive && props.activeColor) return props.activeColor;
        return props.color || "currentColor";
      }};
    }
  }
`;

export const SvgIcon: React.FC<SvgIconProps> = ({
  iconUrl,
  color,
  isActive,
  activeColor,
  width,
  height,
  className,
}) => {
  const [svgContent, setSvgContent] = useState<string>("");

  useEffect(() => {
    const loadSvg = async () => {
      const content = await getSvgContent(iconUrl);
      setSvgContent(content);
    };
    loadSvg();
  }, [iconUrl]);

  return (
    <SvgContainer
      width={width}
      height={height}
      color={color}
      isActive={isActive}
      activeColor={activeColor}
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};
